const prefixes = 'KMGTPEZY';

export const hashrateToString = (hashrate) => {
  if (!hashrate) {
    return '-- H/s';
  }
  const index = hashrate >= 1000 ? Math.min(Math.floor(Math.log10(hashrate) / 3), prefixes.length) : 0;
  const prefix = index > 0 ? prefixes[index - 1] : '';
  const value = (hashrate / 10**(index * 3)).toFixed(3);
  return `${value} ${prefix}H/s`;
};

export const hashrateValue = (hashrate) => {
  const index = hashrate >= 1000 ? Math.min(Math.floor(Math.log10(hashrate) / 3), prefixes.length) : 0;
  return (hashrate / 10**(index * 3));
};

export const hashrateUnit = (hashrate) => {
  const index = hashrate >= 1000 ? Math.min(Math.floor(Math.log10(hashrate) / 3), prefixes.length) : 0;
  const prefix = index > 0 ? prefixes[index - 1] : '';
  return `${prefix}H/s`;
};



// WEBPACK FOOTER //
// /src/services/hashrate.js